import ArrayWithRemove from "./ArrayWithRemove";

export default class ArraySortable extends ArrayWithRemove {
	addSorted (element: any) {
		this.push(element);
		this.bubbleSort(this.length - 1);
	}

	remove (element: any) {
		const idx = this.indexOf(element);
		if (idx !== -1) {
			this.splice(idx, 1);
		}
	}

	reposition (element: any) {
   		this.bubbleSort(this.indexOf(element));
	}

	bubbleSort (index: number) {
		const element = this[index];
		if (index < this.length - 1) {
			let nextIndex = index + 1;
			let nextElement = this[nextIndex];
			while (nextElement._zIndex - element._zIndex < 0) {
				this[nextIndex] = element;
				this[nextIndex - 1] = nextElement;

				nextIndex += 1;
				if (nextIndex >= this.length) {
					break;
				}
				nextElement = this[nextIndex];
			}
		}

		if (index > 0) {
			let previousIndex = index - 1;
			let previousElement = this[previousIndex];
			while (previousElement._zIndex - element._zIndex > 0) {
				this[previousIndex] = element;
				this[previousIndex + 1] = previousElement;

				previousIndex -= 1;
				if (previousIndex < 0) {
					break;
				}
				previousElement = this[previousIndex];
			}
		}
	}

}

export const nullArray = new ArraySortable();
